import { Button, Stack, ToggleButtonGroup, Typography } from '@healthinal/ui';
import { useState } from 'react';
import { useGetChangeLogByPatientSuspense } from '../../../../api/created/changeLog.ts';
import { useGetPatientByIdSuspense } from '../../../../api/generated/patient-controller/patient-controller.ts';
import { useGetUsersSuspense } from '../../../../api/generated/user-controller/user-controller.ts';
import { ChangeHistoryEntry } from '../../../../components/history/ChangeHistoryEntry.tsx';
import {
  filterPatientHistoryEntries,
  getPatientHistorySectionFilterName,
  mapChangeLogEntriesToPatientHistory,
  PATIENT_HISTORY_SECTION_FILTERS,
  PatientHistorySectionFilter,
} from './patientHistory.ts';

export function PatientHistory({ patientId }: { patientId: string }) {
  const [sectionFilter, setSectionFilter] = useState(PatientHistorySectionFilter.ALL);
  const { data: patient } = useGetPatientByIdSuspense(patientId);
  const { data: changeLogEntries } = useGetChangeLogByPatientSuspense(patientId);
  const { data: users } = useGetUsersSuspense();
  const historyEntries = mapChangeLogEntriesToPatientHistory(changeLogEntries, { users });
  const filteredHistoryEntries = filterPatientHistoryEntries(historyEntries, sectionFilter);
  const patientName = `${patient?.firstName ?? ''} ${patient?.lastName ?? ''}`.trim();

  return (
    <Stack gap={2}>
      <Typography level={'h3'}>Fallverlauf</Typography>
      <ToggleButtonGroup value={sectionFilter} sx={{ alignSelf: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
        {PATIENT_HISTORY_SECTION_FILTERS.map((filter) => (
          <Button key={filter} value={filter} onClick={() => setSectionFilter(filter)}>
            {getPatientHistorySectionFilterName(filter)}
          </Button>
        ))}
      </ToggleButtonGroup>
      <Stack gap={2}>
        {filteredHistoryEntries.length === 0 ? (
          <Typography level={'body-md'}>Keine Einträge vorhanden.</Typography>
        ) : (
          filteredHistoryEntries.map((entry) => (
            <ChangeHistoryEntry
              key={entry.id}
              entry={entry}
              subject={entry.subject}
              section={entry.showSectionInTitle ? getPatientHistorySectionFilterName(entry.section) : undefined}
              entityName={patientName}
              actionLabel={entry.actionLabel}
              changedBy={entry.changedByName}
            />
          ))
        )}
      </Stack>
    </Stack>
  );
}
